var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 340 87.1",
    style: {
      enableBackground: "new 0 0 340 87.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.5,0c12.1,0,21.8,9.7,21.8,21.8c0,11-7.7,19.4-18.4,21.5L63,84H52.8L32.4,44.8L9,48.2V84H0V0H38.5z M38.5,8.8H9v30.6 l29.9-4.4c7.1-1.1,12.2-5.6,12.2-13.1C51.1,14.9,45.6,8.8,38.5,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2,85.8C88.4,85.8,75,72,75,50.4V0h9v50.4C84,66.1,93.8,77,110.2,77s26-10.9,26-26.6V0h9v50.4 C145.2,72,131.9,85.8,110.2,85.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.4,103.4L180.4,0h9l-28,103.4H152.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.3,8.8h-49.6v27.5h35.2V45h-35.2v30.2h49.6V84h-58.6V0h58.6V8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3,84h-9V0h9L331,63V0h9v87.1l-62.6-73.6V84z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/EN.615c286b612f779d02352dfc726cff2d.svg";
export { ForwardRef as ReactComponent };